import { render, staticRenderFns } from "./HeroTransportadora.vue?vue&type=template&id=150679eb&scoped=true"
import script from "./HeroTransportadora.vue?vue&type=script&lang=js"
export * from "./HeroTransportadora.vue?vue&type=script&lang=js"
import style0 from "./HeroTransportadora.vue?vue&type=style&index=0&id=150679eb&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "150679eb",
  null
  
)

export default component.exports